import registerClass from "./modules/registerClass";
import projects from "./modules/project";

export default {
  registerClass,
  projects,
};
